import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/cal.com/apps/web/modules/apps/apps-view.tsx");
